// Web mirror of backend src/services/payments/payoutCountries.js — the countries
// whose Stripe account natively settles each base currency. Used to populate the
// payout-country picker on the Connect onboarding step. The backend re-validates
// the chosen country against the org's base currency, so this is UX only.
// Keep in lockstep with the backend map and with currencyOptions.js.

const COUNTRY_LABELS = {
  AU: "Australia",
  US: "United States",
  GB: "United Kingdom",
  CA: "Canada",
  NZ: "New Zealand",
  IE: "Ireland",
  FR: "France",
  DE: "Germany",
  ES: "Spain",
  IT: "Italy",
  NL: "Netherlands",
  PT: "Portugal",
  AT: "Austria",
  BE: "Belgium",
  FI: "Finland",
};

const CURRENCY_TO_COUNTRIES = {
  AUD: ["AU"],
  USD: ["US"],
  GBP: ["GB"],
  CAD: ["CA"],
  NZD: ["NZ"],
  EUR: ["IE", "FR", "DE", "ES", "IT", "NL", "PT", "AT", "BE", "FI"],
};

// Returns [{ code, label }] for the given base currency, or [] if unknown.
export function countriesForCurrency(baseCurrency) {
  const currency = String(baseCurrency || "").toUpperCase();
  const codes = CURRENCY_TO_COUNTRIES[currency] || [];
  return codes.map((code) => ({ code, label: COUNTRY_LABELS[code] }));
}
